import TicketsComponent from "../components/TicketsComponent";
import { useEffect, useRef, useState, useCallback } from "react";
import { Grid } from "../../../../../../Layout/Grid/GridView";
const FinancialView = ({ data }) => {
    const gridListEventTransactionsRef = useRef();

    const onBtnExport = useCallback(() => {
        gridListEventTransactionsRef.current.api.exportDataAsCsv();
    }, []);
    return data ? (
        <div>


            <div className="row mt-1">
                <div className="col-12">
                    <h4>Lista todas as transações do evento</h4>
                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn btn-primary " onClick={onBtnExport}><i className="fa-solid fa-file-export me-3"></i>Exportar CSV</button>
                    </div>

                    <Grid
                        ref={gridListEventTransactionsRef}
                        rows={data.listTransactions}
                        height="100vh"
                        pagination={true}
                        cols={[

                            { headerName: "Origem", field: "origin" },
                            { headerName: "Data da Transação", field: "transaction_date" },
                            { headerName: "Nome do Cliente", field: "client_name" },
                            { headerName: "Telefone", field: "client_phone" },
                            { headerName: "Contribuinte", field: "owner_vat_number" },
                            { headerName: "Email", field: "owner_email" },
                            { headerName: "Valor da Transação", field: "transaction_value" },
                            { headerName: "Método de Pagamento", field: "payment_method" },
                            { headerName: "Data/Hora do Pagamento", field: "payment_datetime" },
                        ]}
                    />
                </div>
            </div>
        </div>
    ) : null;
};

export default FinancialView;
